module.exports = __webpack_public_path__ + "static/media/water.03e0a900.jpg";